import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class HeaderPagesService {
  endpoint:any;
  constructor(private http: HttpClient, private configService: ConfigService) { 
    this.endpoint = this.configService.endpoints;
  }

  resetPassword(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/User/changepassword`, data);
  }

  getLabSetupInformation(LabId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/Lab/${LabId}`);
  }

  getPrinters(key) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/CaseOrder/printers/${key}`);
  }

  updatePrinter(userid, labelprinterid) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/User/${userid}/${labelprinterid}`, null);
  }

  getAllIssues(labCode) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/JiraServiceDesk/GetAllIssues/jql=project=` + labCode);
  }

  getIssueType() {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/JiraServiceDesk/GetIssueTypes`);
  }

  createIssue(data) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/JiraServiceDesk/CreateIssue`, data);
  }

  createDocument(data, issueId) {
    return this.http.post<any>(`${this.endpoint.APIEndpoint}/JiraServiceDesk/AddAttachment/${issueId}`, data);
  }

  getIssueById(issueId) {
    return this.http.get<any>(`${this.endpoint.APIEndpoint}/JiraServiceDesk/GetAllIssueById/${issueId}`);
  }

  forgetPasswordLink(username, email) {
    return this.http.post(`${this.endpoint.LogInAPIEndpoint}/validate/${username}/${email}`, null, { responseType: 'text' });
  }

  licenseAccepted(userId) {
    return this.http.put<any>(`${this.endpoint.APIEndpoint}/User/LicenseAcccepted/${userId}`, null);
  }

}
